import { CollectionViewsState } from './CollectionViewsState';
import { presetsToCategories } from './presetsToCategories';

import { FiltersMap } from '@wix/bex-core';
import { ToolbarCollectionState } from './ToolbarCollectionState';
import { ViewsProps } from '../index';

export function setViewsState<T, F extends FiltersMap>(
  toolbar: ToolbarCollectionState<T, F>,
  viewsProps: ViewsProps<F>,
) {
  const {
    presets,
    onSaveView,
    onSaveViewChanges,
    onDeleteView,
    onRenameView,
    onSetAsDefaultView,
    allItemsViewProps,
  } = viewsProps;

  return (toolbar.viewsState ??= new CollectionViewsState({
    table: toolbar,
    container: toolbar.container,
    presets: presetsToCategories(presets),
    allItemsViewProps,
    onDeleteView,
    onSaveView,
    onSaveViewChanges,
    onSetAsDefaultView,
    onRenameView,
  }));
}
